module.exports = __webpack_public_path__ + "static/media/visacard.783f683f.svg";